import React, { useEffect, useState, useContext } from 'react';
import { AppBar, Toolbar, Button, Box, Select, MenuItem, FormControl, Container, Stack, IconButton,} from '@mui/material';
import { AccountCircleOutlined, ExpandMore, ShoppingBasketOutlined } from '@mui/icons-material';
// import { ReactComponent as Logo } from '../../assets/logo.svg'; 
import logo from '../../assets/logo-esdras7.png';
import { Context } from '../../App';
import AccountMenu from '../ui/AccountMenu';

const Header = () => {
  const {region, setRegion, regions, isConnected} = useContext(Context);

  const [navigationItems, setNavItem] = useState(region===null? [] : [
    { label: 'Accueil', href: '/', active: true },
    { label: 'Faire un don', href: '/donate' },
    // { label: 'Projets', href: '/projets' },
    // { label: 'Institutions', href: '/institutions' },
    // { label: 'Billeterie', href: '/billeterie' },
    { label: 'À propos', href: '/about_us' },
  ]);

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  useEffect(() => {
    // Update the active state based on the current URL
    const currentPath = window.location.pathname;
    setNavItem((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        active: item.href === currentPath,
      }))
    );
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    setNavItem(region===null? [] : [
      { label: 'Accueil', href: '/', active: true },
      { label: 'Faire un don', href: '/donate' },
      // { label: 'Projets', href: '/projets' },
      // { label: 'Institutions', href: '/institutions' },
      // { label: 'Billeterie', href: '/billeterie' },
      { label: 'À propos', href: '/about_us' },])
  }, [region, setRegion]);

  return (
    <>
      <AppBar position="static" sx={{ 
        backgroundColor: 'primary.main', 
        width: '100vw',
        margin: 0,
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)'
      }}>
        <Container maxWidth={false} sx={{ px: { xs: 1, sm: 2 }, width: '100%' }}>
          <Toolbar disableGutters>
            {/* Logo */}
            <Box sx={{ display: 'flex', alignItems: 'center', mr: { xs: 1, md: 2 }, flexShrink: 0 }} onClick={() => window.location.href='/'}>
                <img src={logo} alt="Esdras7 Logo" style={{ height: '50px', flexShrink: 0 }} />
                {/* <Typography variant='h4' color='focus.main' sx={{ fontSize: { xs: '1.25rem', md: '1.75rem' }, whiteSpace: 'nowrap', ml: 1 }}>Esdras7</Typography> */}
                {/* <Typography component={Link} to={'/'} sx={{textDecoration:'none'}}  variant='h4' color='focus.main' >Billetterie fédérale</Typography> */}
            </Box>

            {/* Navigation Menu */}
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center', mx: 2, gap: 1, minWidth: 0, overflow: 'hidden' }}>
              {navigationItems.map((item) => (
                <Button
                  key={item.label}
                  color="inherit"
                  href={item.href}
                  sx={{
                    fontSize: { xs: '0.875rem', md: '1.25rem' },
                    fontWeight: item.active ? 'bold' : 'normal',
                    color: 'secondary.main',
                    px: 1,
                    minWidth: 'auto',
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
            
            {/* Spacer pour pousser les boutons à droite quand navigation cachée */}
            <Box sx={{ flexGrow: 1, display: { xs: 'block', md: 'none' } }} />

            {/* Actions: Panier + Connexion */}
            <Stack direction="row" spacing={1} sx={{ flexShrink: 0, alignItems: 'center' }}>
              <IconButton href='/panier' size='medium'>
                <ShoppingBasketOutlined fontSize='medium' style={{color:'white'}}/>
              </IconButton>
              {isConnected ? <AccountMenu /> : 
                <IconButton href={'/connexion'} size='medium'>
                  <AccountCircleOutlined fontSize='medium' style={{color:'white'}}/>
                </IconButton>
              }
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
 
      {/* Region Selector */}
      {region!==null&&<Container maxWidth={false} sx={{ mt: 2, px: 2 }}>
        <FormControl sx={{ minWidth: 150 }}>
          <Select size='small'
            value={region}
            onChange={(e) => {setRegion(e.target.value); localStorage.setItem('region', e.target.value)}}
            displayEmpty
            sx={{ borderRadius: '10px', '& .MuiSelect-icon': {color: 'primary.main'}}}
            renderValue={(value) => {
              const selectedRegion = regions.find((reg) => reg.num === value);
              return selectedRegion ? capitalize(selectedRegion.nom) : 'Sélectionner une région';
            }}
            IconComponent={ExpandMore} 
          >
            {regions.map((reg) => (
              <MenuItem key={reg.num} value={reg.num} sx={{ textTransform: 'capitalize' }}>
                {reg.nom}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Container>}
    </>
  );
};

export default Header;